.spotify-player-playlists-wrapper {
  overflow-y: auto;
  scrollbar-gutter: stable;
  height: 100%;
  max-height: min(100%, var(--spotify-player-panel-max-height, 60vh));
  box-sizing: border-box;
  flex: 1 1 auto;
  min-height: 0;
  background-color: var(--darkest);
  border: 1px solid var(--grey);
  padding: 0.5em;
  border-radius: 0.5em;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  gap: 0.5em;
}

.spotify-player-playlist-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.8em;
  padding: 0.4em;
  background-color: var(--dark);
  border: 1px solid var(--button-border);
  border-radius: 0.4em;
  cursor: pointer;
  transition: background-color 0.15s ease;
  overflow: hidden;
  min-height: 56px;
  flex-shrink: 0;
}

.spotify-player-playlist-item:hover {
  background-color: var(--grey);
}

.spotify-player-playlist-item.active {
  background-color: var(--accent-color);
}

.spotify-player-playlist-item.active .spotify-player-playlist-info h4 {
  color: var(--darkest);
}

.spotify-player-playlist-item.active .spotify-player-playlist-description,
.spotify-player-playlist-item.active .spotify-player-playlist-meta {
  color: var(--dark);
}

.spotify-player-playlist-image {
  width: 48px;
  height: 48px;
  border-radius: 0.3em;
  pointer-events: none;
  flex-shrink: 0;
  object-fit: cover;
}

.spotify-player-playlist-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--grey);
  color: var(--lighter);
  font-size: 1rem;
  flex-shrink: 0;
}

.spotify-player-playlist-sentinel {
  width: 1px;
  height: 1px;
}

.spotify-player-playlist-loading {
  color: var(--grey);
  animation: spotify-player-pulse 1.2s ease-in-out infinite;
}

@keyframes spotify-player-pulse {
  0%, 100% { opacity: 0.4; }
  50% { opacity: 1; }
}

.spotify-player-playlist-info {
  text-align: start;
  overflow: hidden;
  flex: 1;
  min-width: 0;
}

.spotify-player-playlist-info h4 {
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  font-size: 0.9rem;
  text-overflow: ellipsis;
}

.spotify-player-playlist-description {
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  font-size: 0.75rem;
  text-overflow: ellipsis;
  color: var(--description-color);
  opacity: 0.8;
}

.spotify-player-playlist-meta {
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  font-size: 0.7rem;
  text-overflow: ellipsis;
  color: var(--subtext-color);
}

.spotify-player-playlist-dot {
  opacity: 0.5;
}

.spotify-player-play-button {
  color: var(--blue);
  background-color: var(--dark);
  border: 1px solid var(--darker);
  border-radius: 0.4em;
  cursor: pointer;
  padding: 0.4em 0.6em;
  font-size: 0.85rem;
  transition: background-color 0.15s ease;
  flex-shrink: 0;
}

.spotify-player-play-button:hover {
  background-color: var(--button-hover-background);
  color: var(--magenta);
}
